import React, { Fragment, useState, useRef } from 'react';
import { Buffer } from 'buffer';

// Importacion de componentes de PrimeReact
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from 'primereact/confirmdialog';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';

import { Messages } from 'primereact/messages';

// import Buffer from 'buffer'


// Importacion de Servicios
import { toastShow } from '../../../../../Base/Services/ToastService';
import { textTemplate } from "../../../../../Base/Services/TemplatesServices";
import { downloadBase64Data } from '../../../../../Base/Services/ArchivosService';


import { deleteArchivosRequisa, getArchivosRequisa, getDataArchivo, postArchivosRequisa, tiposArchivosRequisa } from '../../../../../API/Compras/Requisas/ArchivosRequisa';


import './ArchivosRequisicion.scss';

const ArchivosRequisicion = ({ idPurchase, selected }) => {


     // Variables de referencia

    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const msgs3 = useRef(null);
    const tablaArchivos = useRef(null);


    // Variables de estado
    const [modalArchivo, setModalArchivo] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [tipos, setTipos] = useState([]);
    const [archivos, setArchivos] = useState([]);
    const [selectTipo, setSelectTipo] = useState(null)
    const [descripcion, setDescripcion] = useState("");
    const [nombreArchivo, setNombreArchivo] = useState("");
    const [loading, setLoading] = useState(false);

    const valores = window.location?.pathname;


    const getInfo = async (idPurchase) => {
        console.log({idPurchase, hola: 22});
        setLoading(true);
        const t = await tiposArchivosRequisa();
        setTipos(t);
        const a = await getArchivosRequisa(idPurchase);
        setArchivos(a);
        setLoading(false);
    }



    // Funcion para poder visualizar el Componeten Modal
    const openNew = () => {

        if (idPurchase === undefined) {
            if (selected.length > 0) {
                if(selected.length >0){
                    console.log(selected.length);
                    let idRequisa = selected[0]?.IdPurchaseRequest;
                    setModalArchivo(true);
                    getInfo(idRequisa);
                }else{
                    console.log('asdfs');
                    toastShow(toast, 'info', 'Debe seleccionar una requisa.', '');
                }
            } else {
                toastShow(toast, 'info', 'Debe seleccionar una requisa.', '');
            }
        } else {
            console.log('no entro');
            setModalArchivo(true);
            setDescripcion("");
            setNombreArchivo("");
            setSelectTipo(null);
            getInfo(idPurchase);
        }

    }

    const hideDialog = () => {
        setModalArchivo(false);
    }

    const onTipoChange = (e) => {
        setSelectTipo(e.value);
    }



    /// INSEERTAR UN NUEVO ARCHIVO A UNA REQUISA
    const postArchivo = async (arrayAuxiliar) => {
        setLoading(true);
        // console.log(arrayAuxiliar)
        if (descripcion === "" || selectTipo === "") {
            msgs3.current.show({ severity: 'error', summary: 'Error', detail: ' Debe ingresar todo los datos', sticky: true });
        }
        else {
            let id = ""
            if (idPurchase === undefined) {
                id = selected[0].IdPurchaseRequest;
            } else {

                id = idPurchase
            }
            const data = await postArchivosRequisa({
                IdRequisa: id,
                Tipo: nombreArchivo,
                Data: arrayAuxiliar,
                // Nombre: n,
                Nombre: descripcion,
                IdTipo: selectTipo.IdTipoArchivo
            })
            console.log(data);
            msgs3.current.show({ severity: 'success', summary: '', detail: 'Archivo Guardado Exitosamente', sticky: true });
            setArchivos(data)
            setNombreArchivo("");
            setDescripcion("");
            setSelectTipo("");
            // fileUploadRef.current.clear();
            setTimeout(() => {
                msgs3.current.clear();
            }, 3000);
            setLoading(false);
        }

    }

    // OBTENER LA DATA DEL ARCHIVO QUE SE DESEA DESCARGAR
    const getArchivo = async (IdFile) => {
        setLoading(true);
        const data = await getDataArchivo(IdFile);
        if(data.length > 0){
            downloadBase64Data(data[0]);
        }else{
            msgs3.current.show({ severity: 'error', summary: 'Error', detail: 'No se encontro el archivo', sticky: true });
        }
        setLoading(false); 
    }


    const eliminarArchivo = () => {
        setLoading(true);
        selectedData.forEach((select) => {
            let tempo = archivos
            let tempoId = select.IdFile
            let tempoIdRequisa = select.IdRequisa
            postEliminarArchivo(tempoId, tempo, tempoIdRequisa)
        })
        openNew();
        setLoading(false);

    }
    const confirmarEliminacion = () => {
        confirmDialog({
            message: 'Esta seguro que desea eliminar este archivo',
            header: 'Advertencia',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Si",
            accept: () => eliminarArchivo(),
            rejectLabel: "No",
        });
    }



    const postEliminarArchivo = async (Id, tempo, IdRequisa) => {
        const data = deleteArchivosRequisa({
            IdFile: Id,
            IdRequisa: IdRequisa
        })
        setSelectedData([])
        msgs3.current.show({ severity: 'success', summary: '', detail: 'Archivo Eliminado Exitosamente', sticky: true });
        tablaArchivos.current.reset();
    }

    const asignarValores = (e) => {
        if (e.files[0].name === undefined) {
            setNombreArchivo("")
        } else {
            setNombreArchivo(e.files[0].name)
        }
    }

    const guardar = async (e) => {

        const reader = new FileReader();
        reader.readAsArrayBuffer(e.files[0]);
        reader.onloadend = function (event) {
            postArchivo(Buffer.from(reader.result));
        }
    }



    const header = (
        <div className="flex align-items-center py-2">
            <div className='archivo__grid-container'>
                <span>Nombre  <InputText value={nombreArchivo} onChange={(e) => setNombreArchivo(e.target.value)} /></span>
                <span style={{ marginLeft: 5 }}> Descripcion: <InputText value={descripcion} onChange={(e) => setDescripcion(e.target.value)} /></span>
                <span style={{ marginLeft: 5, marginTop: 10 }}> Tipo:</span>
                <span style={{ marginLeft: 5, width: 150 }}>
                    <Dropdown value={selectTipo} onChange={onTipoChange} options={tipos} optionLabel="TipoArchivo" placeholder="Tipo" />
                </span>

                <FileUpload ref={fileUploadRef} name="demo[]" onUpload={null} maxFileSize={6000000} onSelect={e => asignarValores(e)}
                    previewWidth={0} customUpload uploadHandler={e => guardar(e)} chooseLabel='Nuevo' uploadLabel='Agregar' cancelLabel='Cancelar' />

                <Button icon="pi pi-times" label='Eliminar' className="p-button-danger" onClick={confirmarEliminacion}
                    tooltip="Eliminar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1 }} />
            </div>
        </div>
    )

    const archivoTemplate = (rowData) => {
        return <Button type="button" icon="pi pi-download" className="p-button-secondary" tooltip="Archivo5000s" id="btnDescargar"
            tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1.5, height: 40 }} onClick={() => getArchivo(rowData.IdFile)} />
    }


    const columns = [
        {
            selectionMode: "multiple",
            frozen: "frozen",
            className: "colum-width-Xsmall",
        },
        {
            field: 'Tipo',
            header: 'Nombre',
            className: "colum-width-XXlarge",
            // body: (rowData) => textTemplate(rowData.Tipo, (e) => getDataArchivo(rowData.IdFile)),
            body: (rowData) => textTemplate(rowData.Tipo)
        },
        {
            field: 'Nombre',
            header: 'Descripcion',
            className: "colum-width-Xlarge",
            body: (rowData) => textTemplate(rowData.Nombre),

        },
        {
            field: 'Archivo',
            header: 'Archivo',
            body: (rowData) => archivoTemplate(rowData)
        },
        {
            field: 'TipoArchivo',
            header: 'TipoArchivo'
        }

    ];

    const footer = (
        <div>
            {/* <Button className='p-button-outlined' label="No" icon="pi pi-times" o} /> */}
            {/* <Button className='' label="Aceptar" icon="pi pi-check" onClick={hideDialog} /> */}
        </div>
    );

    return (
        <div id={'modalArchivosRequisa'}>

            <Button type="button" icon="pi pi-folder-open" className="encabezado__herramienta-botones" tooltip="Archivos"
                tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{}} onClick={openNew} />
            <Toast position="bottom-right" ref={toast} />

            <Dialog className='modal__contenedor' footer={footer} visible={modalArchivo} position="top" modal
                onHide={() => hideDialog('displayPosition')} resizable={false} closable={true}>
                {/* <ConfirmDialog /> */}
                {/* <Loader loading={loading} querySelector={'#modalArchivosRequisa'} /> */}

                <DataTable ref={tablaArchivos} value={archivos} size={'small'} stripedRows className="editable-cells-table" responsiveLayout="scroll" breakpoint="690px" columnResizeMode='fit'
                    autoLayout rowHover header={header} selectionMode="checkbox" selection={selectedData} scrollable scrollHeight="65vh" dragSelection
                    onSelectionChange={e => setSelectedData(e.value)} editMode="cell" emptyMessage="Sin archivos." loading={loading}>
                    {
                        columns.map(({ field, header, selectionMode, body, className }, index) => {
                            return <Column key={index} field={field} header={header} body={body} selectionMode={selectionMode} className={className}
                            />
                        })
                    }
                </DataTable>
                <Messages ref={msgs3} life={2000} />
            </Dialog>
        </div>
    )
}

export default ArchivosRequisicion;

